/**
 * Generates a consistent color based on the employee's name
 * Uses a hash function to ensure the same name always gets the same color
 */

export const AVATAR_COLORS = [
  '#6366F1', // Indigo
  '#8B5CF6', // Violet
  '#EC4899', // Pink
  '#EF4444', // Red
  '#F97316', // Orange
  '#F59E0B', // Amber
  '#10B981', // Emerald
  '#14B8A6', // Teal
  '#06B6D4', // Cyan
  '#3B82F6', // Blue
];

export const getAvatarColor = (name: string): string => {
  if (!name) return AVATAR_COLORS[0];
  
  // Generate a hash from the name
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Use the hash to get a consistent index
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};

/**
 * Gets the initials from a name (up to 2 characters)
 */
export const getInitials = (name: string): string => {
  if (!name) return '?';
  
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  
  // Get first letter of first two words
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

/**
 * Checks if a string is a valid image URL
 */
export const isValidImageUrl = (url: string | undefined | null): boolean => {
  if (!url) return false;
  
  // Check if it's a data URL or valid URL
  return url.startsWith('data:') || 
         url.startsWith('http://') || 
         url.startsWith('https://') ||
         url.startsWith('blob:');
};
